/* istanbul ignore file */
import type { Marker } from 'domain/gpo/cockpit/facade/marker/types';

const OFFSET = 10;

class HighlightActivityMarker implements Marker {
  activityId: string;

  html: string;

  position: {
    top: number;
    left: number;
  };

  constructor(activityId: string, activityHeight: number, activityWidth: number) {
    this.activityId = activityId;

    const height = activityHeight + OFFSET * 2;
    const width = activityWidth + OFFSET * 2;
    this.html = `<div class="highlightActivity" style="width:${width}px;height: ${height}px;" />`;
    this.position = {
      left: 0 - OFFSET,
      top: 0 - OFFSET,
    };
  }
}

export default HighlightActivityMarker;
